import { styled } from 'styled-system/jsx'

const PageStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
})

const PageHeader = styled('div', {
  base: {},
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    marginTop: '4px',
  },
})

const SectionTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '18px',
    fontWeight: '600',
    color: 'quickpass.ink',
    marginBottom: '12px',
  },
})

const BalanceLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

const BalanceAmount = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '26px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const LedgerList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '16px',
  },
})

const ChargeList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '16px',
  },
})

const ChargeRow = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    borderRadius: '10px',
    border: '1px solid #EFEDF5',
  },
})

const ChargeRowLeft = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: '0',
  },
})

const ChargeRowRight = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '6px',
  },
})

const LedgerRow = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: '8px',
    padding: '12px 0',
    borderTop: '1px solid #EFEDF5',
  },
})

const LedgerRowLeft = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
})

const LedgerDescription = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const LedgerAmount = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: '600',
    color: 'quickpass.ink',
    textAlign: 'right',
  },
})

const LedgerMeta = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: '#8A8398',
  },
})

const QuietText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

const BalanceActions = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '16px',
  },
})

const PayHint = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: '#8A8398',
    marginTop: '8px',
  },
})

const PaymentBanner = styled('div', {
  base: {
    borderRadius: '10px',
    padding: '12px 16px',
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
  },
  variants: {
    tone: {
      success: {
        backgroundColor: '#E7F8EF',
        color: '#1E7A4D',
      },
      cancelled: {
        backgroundColor: '#FBECEC',
        color: '#9B3B3B',
      },
    },
  },
  defaultVariants: {
    tone: 'success',
  },
})

const AutopaySection = styled('div', {
  base: {
    marginTop: '20px',
    paddingTop: '20px',
    borderTop: '1px solid #EFEDF5',
  },
})

const AutopayRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

const AutopayText = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: '1 1 220px',
  },
})

const AutopayLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const AutopayHint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    lineHeight: 1.4,
  },
})

const PaidSummary = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    marginTop: '10px',
  },
})

const LedgerRowActions = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '10px',
    marginTop: '6px',
  },
})

const StatusPill = styled('span', {
  base: {
    alignSelf: 'flex-start',
    paddingX: '8px',
    paddingY: '2px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
  },
  variants: {
    tone: {
      settled: { backgroundColor: '#E7F8EF', color: '#1E7A4D' },
      pending: { backgroundColor: '#FFF4D6', color: '#8A6D1A' },
      failed: { backgroundColor: '#FBECEC', color: '#9B3B3B' },
    },
  },
  defaultVariants: {
    tone: 'pending',
  },
})

const ReceiptLink = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.primary',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
    transition: 'opacity {durations.fast} {easings.appleStandard}',
    _hover: {
      opacity: '0.7',
    },
  },
})

export {
  PageStack,
  PageHeader,
  PageTitle,
  PageSubtitle,
  SectionTitle,
  BalanceLabel,
  BalanceAmount,
  LedgerList,
  ChargeList,
  ChargeRow,
  ChargeRowLeft,
  ChargeRowRight,
  LedgerRow,
  LedgerRowLeft,
  LedgerDescription,
  LedgerAmount,
  LedgerMeta,
  QuietText,
  BalanceActions,
  PayHint,
  PaymentBanner,
  AutopaySection,
  AutopayRow,
  AutopayText,
  AutopayLabel,
  AutopayHint,
  PaidSummary,
  LedgerRowActions,
  StatusPill,
  ReceiptLink,
}
